// This file was auto-generated by Fern from our API Definition.
export var PendingInput;
(function (PendingInput) {
    PendingInput.Policy = {
        Queue: "queue",
        Steer: "steer",
    };
})(PendingInput || (PendingInput = {}));
